var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaret(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Arrow_Up_24x24",
    "data-name": "Icon Arrow Up 24x24",
    transform: "translate(24 24) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27996",
    "data-name": "Rectangle 27996",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(4 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50422",
    "data-name": "Path 50422",
    d: "M18,18.736l-6.058,6.058a1.086,1.086,0,0,1-1.714-.114,1.2,1.2,0,0,1,.114-1.543l6.858-6.8a1.086,1.086,0,0,1,1.6,0l6.858,6.8a1.2,1.2,0,0,1,.114,1.543,1.086,1.086,0,0,1-1.714.114Z",
    transform: "translate(-10.001 -16.985)",
    fill: "#09828b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.105ac2442579376807e26bd0f51d6a12.svg";
export { ForwardRef as ReactComponent };